export class SmartNavigatorExceptionConstant {

  //#region Properties

  public static readonly invalidScreenCode = 'INVALID_SCREEN_CODE';

  public static readonly invalidNavigationRequest = 'INVALID_NAVIGATION_REQUEST';

  public static readonly screenCodeMappingNotFound = 'SCREEN_CODE_MAPPING_NOT_FOUND';

  public static readonly urlNotFound = 'SCREEN_URL_NOT_FOUND';

  //#endregion

}
